export default function RemToPX(rem) {
	if(!typeof rem === "number") {
		throw Error(`Invalid input of type: "${typeof rem}" provided to RemToPX. It expects a number as input`);
	}
	const baseSize = parseFloat(
		getComputedStyle(document.documentElement).fontSize
	);
	return Math.round(rem * baseSize);
}